import logo from "../assets/recall-rush-logo.png";

export default function Header() {
  return (
    <header>
      <nav class=" border-gray-200 px-4 lg:px-6 py-2.5">
        <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl sm:row-span-4">
          <a href="#" class="flex items-center">
            <img
              src={logo}
              class="mr-3 h-6 sm:h-9 rounded-md"
              alt="Flowbite Logo"
            />
            <span class="self-center text-xl text-[#af61dd]  font-semibold whitespace-nowrap">
              Recall Rush
            </span>
          </a>
          <div class="flex items-center lg:order-2 sm:flex-col lg:flex-row">
            <p className="mr-4 text-[#af61dd]">+92 312 4422229</p>
            <p className="mr-4 text-[#af61dd] ">info@thekaizenglobal.com</p>
            <a
              href="https://play.google.com/store/apps/details?id=com.hrassistancepra&pcampaignid=web_share"
              class="text-white focus:ring-4 bg-[#af61dd] hover:bg-fuchsia-700 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 hover:bg-('#1c70b7') focus:outline-none focus:ring-gray"
            >
              Download Now
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}
